module.exports = __webpack_public_path__ + "img/ky.5f7012e6.svg";